<template>
  <div class="header-ally">
    <div class="left-back" v-show="hideBack"></div>
    <img src="../assets/images/2-1_01.png" alt="" class="left-back" @click="back" v-show="!hideBack && !isCustomMethod">
    <img src="../assets/images/2-1_01.png" alt="" class="left-back" @click="customMethod" v-show="!hideBack && isCustomMethod">
    <p class="header-title">{{headTitle}}</p>
    <!--<img src="../assets/images/2-1_03.png" alt="" class="right-menu" @click="showMenu">-->
  </div>
</template>

<script>
  export default {
    name: "pageHead",
    props: {
        headTitle: "",
        hideBack: false,
        isCustomMethod: false,
        hideMenu: false,
        zIndexHigh: { //是否高层级
            type: Boolean,
            default: false
        },
    },
    methods:{
      back:function () {
        window.history.back();
      },
      //自定义返回
      customMethod(){
          this.$emit("customMethod");
      },
      showMenu:function () {

      }
    }
  }
</script>

<style>
  .header-ally{
    height: 1.06rem;
    background-color: #e6e6e7;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    display: -webkit-box; /* Safari */
    display: box;
    z-index: 100;
  }
  .header-ally .left-back,.header-ally .right-menu{
    width: 0.8rem;
  }
  .header-ally p{
    -webkit-box-flex: 1;
    line-height: 1.06rem;
    text-align: center;
    color: #19171b;
    font-size: 0.3rem;
    margin-right: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/ally/components/header.vue